<template>
  <div class="remark-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'jggs'"></list-left>
      <div class="page-right">
        <div class="info-top">
          <div class="info-title">{{obj.name}}</div>
          <div class="info-desc">
            {{obj.address}}
          </div>
          <div class="lab-item">
            <div class="lab-left">备案证书编号：</div>
            <div class="lab-right">{{obj.certificateNo}}</div>
          </div>
          <div class="lab-item">
            <div class="lab-left">统一社会信用代码：</div>
            <div class="lab-right">{{obj.creditCode}}</div>
          </div>
          <div class="lab-item">
            <div class="lab-left">门店数量：</div>
            <div class="lab-right">{{obj.storeNum}}</div>
          </div>
        </div>
        <remark-box class="mg-t20 "></remark-box>
     
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import remarkBox from "@/components/remarkBox";
import { companyDetail } from "@/assets/api/company";
export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    listLeft,
    remarkBox
  },

  data() {
    return {
      tableData: [
      ],
      id: this.$route.query.id,
      obj: '',
    };
  },
  computed: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await companyDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data
        console.log(this.obj)
      }
    },
  },
};
</script>

<style lang="less">
.remark-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .page-right {
      width: 848px;
      .info-top {
        padding: 20px;
        border: 1px solid #eee;
        line-height: 26px;
        background: url("../../assets/img/info-bg.jpg") no-repeat top right;
        height: 192px;
        .info-title {
          font-size: 22px;
          font-weight: 700;
          line-height: 36px;
        }
        .info-desc {
          color: #999;
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
      .info-bottom {
        line-height: 32px;
        padding: 20px;
        border: 1px solid #eee;
        border-top: none;
      }
      .i-r-t {
        font-size: 16px;
        margin: 20px 0;
      }
      .lab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        margin-bottom: 6px;
        .lab-left {
          width: 126px;
          flex-shrink: 0;
        }
        .lab-right {
          flex: 1;
        }
      }
      .lab-row {
        display: flex;
        & > div {
          flex: 1;
        }
      }
    }

    .mg-t20 {
      margin-top: 20px;
    }
  
  }
  .look-remark {
     color: #fff;
    background-color: #B1191A;
    font-size: 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 288px;
    height: 46px;
    cursor: pointer;
  }
}
</style>